import parseArcaResponse from '../parseArcaResponse';
import { WithdrawalRequest } from './interfaces/WithdrawalRequest';
import { GenericBackendResponse } from '../genericBackendResponse';

/**
 * Solicitudes del usuario, opcionalmente acotadas a un plan.
 *
 * Es lo que decide el estado del botón en la card de rescates: si el plan tiene
 * una solicitud en curso, el botón se sustituye por el badge de "Pendiente".
 */
const getMyWithdrawalRequests = async (
	token: string,
	userEppConfigId?: string
): Promise<WithdrawalRequest[]> => {
	const query = userEppConfigId ? `?userEppConfigId=${encodeURIComponent(userEppConfigId)}` : '';

	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/pension-plan-withdrawals/my${query}`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);

	const body = await parseArcaResponse<GenericBackendResponse<WithdrawalRequest[]>>(response);

	return body.data ?? [];
};

export default getMyWithdrawalRequests;
